import { emptyClientInput } from "../shared/constants";
import { ClientInput } from "../shared/interfaces";
import { validateClientInputs } from "../utils/validations/validateClientInputs";
import { clientInputKeys } from "../config/constants";
import parseSupplyChainTrackingEvents from "../utils/parseSupplyChainTrackingEventsInputs";
import { SUPPLY_CHAIN_TRACKING_EVENTS_INPUT } from "../shared/strings/constants";
import { useMemo } from "react";

export default function useClientInputs() {
    const { clientInput, isClientInputValid } = useMemo(() => {
        const input: ClientInput = Object.assign({}, emptyClientInput);
        
        clientInputKeys.forEach(({ key, clientKey, defaultValue }) => {
            const element = document?.getElementById(clientKey) as HTMLInputElement;
            
            if (key === SUPPLY_CHAIN_TRACKING_EVENTS_INPUT) {
                input[key] = parseSupplyChainTrackingEvents(clientKey);
            } else {
                input[key] = element?.value || defaultValue;
            }
            
        });
        
        const isValid = validateClientInputs(input);
        return { clientInput: input, isClientInputValid: isValid };
    }, []);
    
    return { clientInput, isClientInputValid };
}   